import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { maskCPF, maskPhone, brl } from "@/lib/pricing";
import { Toggle, Decoracao } from "@/components/reserva/Decoracao";

const Field = ({ label, error, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-2 block text-xs font-bold uppercase tracking-[0.16em] text-[#3d4a34]">{label}</span>
    {children}
    {error && <span className="mt-1 block text-sm text-red-700">{error}</span>}
  </label>
);

const inputCls = "h-12 rounded-none border-[#c9c0aa] bg-white text-base text-[#263228] focus-visible:ring-[#7ab51d]";

export const FormReserva = ({ form, set, errors, total, maxHospedes }) => {
  const on = (k, fn = (v) => v) => (e) => set(k, fn(e.target.value));
  return (
    <div data-testid="booking-form" className="space-y-8">
      <div className="grid gap-6 sm:grid-cols-2">
        <Field label="Nome completo *" error={errors.nome} className="sm:col-span-2">
          <Input data-testid="booking-form-name-input" className={inputCls} value={form.nome} onChange={on("nome")} />
        </Field>
        <Field label="Data de nascimento *" error={errors.nascimento}>
          <Input data-testid="booking-form-birthdate-input" type="date" max={new Date().toISOString().slice(0, 10)} className={inputCls} value={form.nascimento} onChange={on("nascimento")} />
        </Field>
        <Field label="CPF *" error={errors.cpf}>
          <Input data-testid="booking-form-cpf-input" inputMode="numeric" placeholder="000.000.000-00" className={inputCls} value={form.cpf} onChange={on("cpf", maskCPF)} />
        </Field>
        <Field label="E-mail *" error={errors.email}>
          <Input data-testid="booking-form-email-input" type="email" className={inputCls} value={form.email} onChange={on("email")} />
        </Field>
        <Field label="Telefone (WhatsApp) *" error={errors.telefone}>
          <Input data-testid="booking-form-whatsapp-input" inputMode="tel" placeholder="(12) 99999-9999" className={inputCls} value={form.telefone} onChange={on("telefone", maskPhone)} />
        </Field>
        <Field label="Nome do acompanhante *" error={errors.acompanhante}>
          <Input data-testid="booking-form-companion-input" className={inputCls} value={form.acompanhante} onChange={on("acompanhante")} />
        </Field>
        <Field label="Número de hóspedes *" error={errors.hospedes}>
          <select data-testid="booking-form-guests-select" value={form.hospedes} onChange={on("hospedes")} className={`${inputCls} w-full border px-3`}>
            {Array.from({ length: maxHospedes }, (_, i) => i + 1).map((n) => (
              <option key={n} value={n}>
                {n} {n === 1 ? "hóspede" : "hóspedes"}
              </option>
            ))}
          </select>
        </Field>
      </div>

      <div className="grid gap-8 border-t border-[#d9d2c1] pt-8 sm:grid-cols-2">
        <div>
          <span className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-[#3d4a34]">Vai levar pet? (+R$ 200,00)</span>
          <Toggle testid="booking-form-pet" value={form.pet ? "sim" : "nao"} onChange={(v) => set("pet", v === "sim")} />
        </div>
        <div>
          <span className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-[#3d4a34]">Forma de pagamento *</span>
          <Toggle testid="booking-form-payment" value={form.pagamento} onChange={(v) => set("pagamento", v)} options={[["pix", "PIX"], ["cartao", "Cartão de crédito"]]} />
          {form.pagamento === "cartao" && (
            <select
              data-testid="booking-form-installments-select"
              value={form.parcelas}
              onChange={on("parcelas")}
              className={`${inputCls} mt-4 w-full border px-3`}
            >
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={n}>
                  {n}x de {brl(total / n)} sem juros
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      <div className="border-t border-[#d9d2c1] pt-8">
        <span className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-[#3d4a34]">Deseja decoração romântica?</span>
        <Toggle
          testid="booking-form-decoration"
          value={form.decoracao ? "sim" : "nao"}
          onChange={(v) => {
            set("decoracao", v === "sim");
            if (v === "nao") set("decoracao_opcao", "");
          }}
        />
        {form.decoracao && <Decoracao value={form.decoracao_opcao} onChange={(v) => set("decoracao_opcao", v)} error={errors.decoracao_opcao} />}
      </div>

      <Field label="Alguma solicitação especial?" className="border-t border-[#d9d2c1] pt-8">
        <Textarea data-testid="booking-form-special-request-input" rows={4} className="rounded-none border-[#c9c0aa] bg-white text-base focus-visible:ring-[#7ab51d]" value={form.observacoes} onChange={on("observacoes")} />
      </Field>
    </div>
  );
};
